"use strict";

define('service/notification',['require','exports','module','appkit/service','underscore','model/notification','model/sort','model/message.template','libs/spf.helper','libs/route.helper','uikit/uikit','view/notifications','view/notification.item','view/notifications/instant.notifications','langs','config'],function (require, exports, module) {
  var Service = require('appkit/service');
  var _ = require('underscore');
  var Notification = require('model/notification');
  var Sort = require('model/sort');
  var MessageTemplate = require('model/message.template');
  var SPFHelper = require('libs/spf.helper');
  var RouteHelper = require('libs/route.helper');
  var UIKit = require('uikit/uikit');
  var NotificationsView = require('view/notifications');
  var NotificationItemView = require('view/notification.item');
  var InstantNotifications = require('view/notifications/instant.notifications');
  var langs = require('langs');
  var config = require('config');
  var NotificationService = Service.extend({
    replies: {
      'build:notification:dropdown': 'buildNotificationDropdown',
      'build:instantNotifications': 'buildInstantNotifications',
      'clear:instantNotifications': 'clearInstantNotifications'
    },
    events: {
      'resize:menu': 'resizeNotifications'
    },
    requestGlobalMessages: function requestGlobalMessages() {
      var globalMessages = new MessageTemplate({
          'code.name': 'IRB.SYSTEM_BANNER',
          'templateType.name': 'Notification'
        }),
        app = this.app;
      this.listenTo(globalMessages, 'sync', function () {
        var content = globalMessages.get('content');
        if (content) {
          app.instantNotifications.add({
            autoClose: false,
            details: content,
            fluid: true
          });
        }
      });
      return globalMessages;
    },
    resizeNotifications: function resizeNotifications(changes) {
      $('#notifications').css('padding-left', changes.left);
    },
    clearInstantNotifications: function clearInstantNotifications() {
      app.instantNotifications.reset([]);
    },
    buildInstantNotifications: function buildInstantNotifications() {
      return new InstantNotifications();
    },
    buildNotificationDropdown: function buildNotificationDropdown() {
      var app = this.app,
        notificationLabel = null,
        notificationMenuIcon = null,
        notificationSpfHelper = null,
        notificationCountSpfHelper = null,
        notificationPopup = null,
        notificationsView = null,
        toBeDeleted = null,
        stillFetching = false,
        notifications = Notification.all(config.APP_LEGACY_NAME),
        notificationCount = Notification.all(config.APP_LEGACY_NAME);
      notificationLabel = new UIKit.Label({
        floating: true,
        circular: true,
        color: 'red',
        size: 'mini',
        visible: false
      });
      notificationMenuIcon = new UIKit.Menu.Item({
        icon: 'bell',
        label: notificationLabel,
        link: true
      });
      notificationSpfHelper = new SPFHelper(notifications).setSortField('createDate').setSortDirection(Sort.DESCENDING).setPaginateSize(10);
      notificationCountSpfHelper = new SPFHelper(notificationCount).setPaginateSize(1).setFilterParams({
        viewed: false
      });
      notificationPopup = new UIKit.Popup({
        showOn: 'click',
        width: UIKit.Popup.WIDE,
        position: UIKit.Popup.BOTTOM_RIGHT,
        triggerAriaLabel: langs.phrase('App.Notifications.Trigger.ARIALabel'),
        triggerAriaLabelledby: notificationLabel.el.id + ' ' + notificationMenuIcon.el.id
      }).attach(notificationMenuIcon).on('change:visible', function () {
        app.execute('achievement:unlock', 'You\'ve got mail');
        notificationMenuIcon.active = notificationPopup.visible;
      });
      notificationsView = notificationPopup.content = new NotificationsView({
        width: 300,
        maxTableHeight: 300,
        childView: NotificationItemView,
        canRemove: true,
        canDeleteAll: true,
        notificationCount: 0
      });
      notificationsView.table.selection = UIKit.Table.MANUAL_SELECTION;
      notificationsView.table.padded = true;
      notificationsView.table.sortable = true;
      notificationsView.table.selectable = true;
      notificationsView.table.collection = notifications;
      notificationsView.table.on('row:press', function (view) {
        var model = view.model,
          link = null;
        if (model === toBeDeleted) {
          return;
        }
        switch (model.get('kind')) {
          case 'Workflow':
            link = new RouteHelper('submission:detail').add(model.get('ownerId'), {
              studyId: 'studyId',
              documentId: 'id'
            }).get('link');
            break;
          case 'Study':
            link = new RouteHelper('study:detail').add(model.get('ownerId'), {
              studyId: 'id'
            }).get('link');
            break;
        }
        model.markViewed();
        notificationPopup.visible = false;
        if (link) {
          app.navigate(link, {
            trigger: true
          });
        }
      });
      this.listenTo(notificationPopup, 'popup:hidden', function () {
        $('a[aria-label="Notifications"]').blur();
      });
      notificationsView.listenTo(notifications, 'request', function () {
        stillFetching = true;
      }).listenTo(notifications, 'sync', function () {
        stillFetching = false;
      }).on("actions:dropdown:hide", function () {
        $("#notifications-menu").removeClass("active transition visible");
        $("#notifications-menu").attr({
          "aria-expanded": "false"
        });
      }).on('action', function (action) {
        switch (action) {
          case 'markAllRead':
            notificationSpfHelper.resetPage();
            Notification.markAllAsViewed(notifications).promise().then(function () {
              notificationsView.scrollHandler.scrollToTop();
              notifications.fetch();
              notificationCount.fetch();
            });
            notificationsView.actions.render();
            break;
          case 'deleteAll':
            notificationSpfHelper.resetPage();
            Notification.deleteAll(notifications).promise().then(function () {
              notificationsView.scrollHandler.scrollToTop();
              notifications.fetch();
              notificationCount.fetch();
            });
            notificationsView.actions.render();
            break;
          case 'toggleMuteNotifications':
            notificationsView.actions.collection.at(2).set({
              text: 'Mute Notifications'
            });
            notificationLabel.visible = false;
            if (this.notificationCount > 0) {
              notificationLabel.visible = true;
            }
            if (!app.muteOption) {
              notificationsView.actions.collection.at(2).set({
                text: 'Unmute Notifications'
              });
              notificationLabel.visible = false;
            }
            app.channel.trigger('notification:muteToggle', app.userSettings);
            notificationsView.actions.render();
            break;
        }
      }).on('table:add:child', function (table, view) {
        var model = view.model;
        function updateView() {
          if (model.get('viewDate')) {
            view.active = false;
          } else {
            view.active = true;
          }
        }
        view.listenTo(model, 'change:viewDate', updateView);
        if (model.get('ownerId') == null) {
          view.selectable = false;
        }
        updateView();
      }).listenTo(notifications, 'change:viewDate destroy', _.debounce(function () {
        notificationCount.fetch();
      })).listenTo(notifications, 'destroy', _.debounce(function () {
        notifications.fetch({
          remove: false
        });
      })).listenTo(notificationCountSpfHelper.paginate, 'change:totalElements', function () {
        var count = notificationCountSpfHelper.paginate.get('totalElements');
        this.notificationCount = count;
        if (count > 0) {
          notificationLabel.visible = true;
          notificationLabel.text = String(count);
        } else {
          notificationLabel.visible = false;
        }
        notificationsView.actions.collection.at(2).set({
          text: 'Mute Notifications'
        });
        if (!_.isUndefined(app.userSettings)) {
          if (app.muteOption) {
            notificationsView.actions.collection.at(2).set({
              text: 'Unmute Notifications'
            });
            notificationLabel.visible = false;
          }
        }
        notificationsView.actions.render();
      }).on('table:row:before:add:child', function (table, row, child, model, column) {
        row.$('td').css('cursor', 'pointer');
        if (child.getOption('name') === 'delete') {
          row.listenTo(child, 'press', function () {
            toBeDeleted = model;
            model.destroy({
              wait: true,
              animate: 'scale'
            });
          });
        }
      }).listenTo(app.channel, 'settings:fetched', function () {
        notifications.fetch({
          remove: false
        });
        notificationCount.fetch();
      }).listenTo(app.channel, 'heartbeat:change:lastNotificationDate', function () {
        notifications.fetch({
          remove: false
        });
        notificationCount.fetch();
      }).listenTo(app.channel, 'user:settings', function () {
        notificationsView.actions.collection.at(2).set({
          text: 'Mute Notifications'
        });
        notificationLabel.visible = false;
        if (this.notificationCount > 0) {
          notificationLabel.visible = true;
        }
        if (!_.isUndefined(app.userSettings)) {
          if (app.muteOption) {
            notificationsView.actions.collection.at(2).set({
              text: 'Unmute Notifications'
            });
            notificationLabel.visible = false;
          }
        }
        notificationsView.actions.render();
      }).on('scroll:bottom', function () {
        if (notificationSpfHelper.hasNextPage()) {
          notificationsView.loadingText.visible = true;
          if (!stillFetching) {
            notificationSpfHelper.incrementPage().fetch({
              remove: false
            });
          }
        } else {
          notificationsView.loadingText.visible = false;
        }
      });
      return notificationMenuIcon;
    }
  });
  module.exports = NotificationService;
});

